import * as tslib_1 from "tslib";
import filterConversationsByIsReadValue from '../helpers/filterConversationsByIsReadValue';
import * as suppressedItemIdsMapOperations from '../helpers/suppressedItemIdsMapOperations';
import markConversationsAsReadService from '../services/markConversationsAsReadService';
import { lazyAddMarkAsReadDiagnostics } from 'owa-group-readunread-diagnostics';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import { getRowKeysFromRowIds, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import getContextFolderIdForTable from 'owa-mail-list-store/lib/utils/getContextFolderIdForTable';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import { getApplyConversationActionContext, getTableConversationRelation, } from 'owa-mail-list-store';
import { userMailInteractionAction } from 'owa-mail-actions';
import datapoints from '../datapoints';
export default action('markConversationsAsReadBasedOnConversationIds', datapoints.markConversationAsReadDatapoint)(function markConversationsAsReadBasedOnConversationIds(conversationIds, tableView, isReadValue, isExplicit, actionSource, instrumentationContexts) {
    var rowKeys = getRowKeysFromRowIds(conversationIds, tableView);
    var rowKeysToUpdate = filterConversationsByIsReadValue(rowKeys, tableView.id, isReadValue);
    if (rowKeysToUpdate.length == 0) {
        // Nothing to update
        return;
    }
    // Update suppressed state if user explicitly marks a single selected conversation as read/unread
    if (conversationIds.length == 1 && tableView.selectedRowKeys.size == 1) {
        var conversationId = MailRowDataPropertyGetter.getRowIdString(rowKeysToUpdate[0], tableView);
        var selectedConversationRowRelation = getTableConversationRelation(tslib_1.__spread(tableView.selectedRowKeys.keys())[0], tableView.id);
        if (conversationId == selectedConversationRowRelation.id) {
            var itemIds = selectedConversationRowRelation.itemIds;
            if (isReadValue) {
                // If mark the conversation read, always remove all item ids and clear the timestamp
                suppressedItemIdsMapOperations.clear();
            }
            else {
                if (isExplicit) {
                    // If mark conversation as unread explicitly, set the suppressed state by adding all itemIds
                    suppressedItemIdsMapOperations.add(itemIds);
                }
                else {
                    trace.warn('Invalid scenario to implicitly mark conversation as unread.');
                }
            }
        }
    }
    // Dispatch action to update the store state
    markConversationsAsReadStoreUpdate(conversationIds, tableView.id, isReadValue);
    // Tracking the mark as read operation for the diagnostics panel
    lazyAddMarkAsReadDiagnostics.import().then(function (addMarkAsReadDiagnostics) {
        addMarkAsReadDiagnostics(tableView.tableQuery, false /* isActingOnAllItemsInTable */, isReadValue, actionSource, conversationIds);
    });
    var contextFolderId = getContextFolderIdForTable(tableView);
    var conversationActionContexts = rowKeysToUpdate.map(function (rowKey) {
        return getApplyConversationActionContext(rowKey, tableView.id);
    });
    var requestOptions = getMailboxInfo(tableView).requestOptions;
    // Make service request
    markConversationsAsReadService(conversationActionContexts, isReadValue, contextFolderId, requestOptions);
    if (isReadValue) {
        isExplicit
            ? userMailInteractionAction('MarkAsRead', instrumentationContexts)
            : userMailInteractionAction('MarkAsReadImplicit', instrumentationContexts);
    }
    else {
        userMailInteractionAction('MarkAsUnread', instrumentationContexts);
    }
});
//# sourceMappingURL=markConversationsAsReadBasedOnConversationIds.js.map